import { validateAnyContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { INLINE_BUTTON, LEAF_RICH_BLOCKS } from '../types';

export const schema = Schema.create({
    inlines: {
        [INLINE_BUTTON]: {
            isVoid: true,
            parent: {
                types: LEAF_RICH_BLOCKS,
            },
            data: {
                label: (label) => typeof label === 'string',
                kind: (kind) =>
                    typeof kind === 'string' && (kind === 'primary' || kind === 'secondary'),
                icon: (icon) => icon === undefined || typeof icon === 'string',
                ref: validateAnyContentReference,
            },
        },
    },
});
